var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame-previewer",attrs:{"data-tid":_vm.album.tid}},[_c('section',{staticClass:"preview-zone"},[_c('div',_vm._b({staticClass:"page",domProps:{"innerHTML":_vm._s(_vm.page)}},'div',_vm.pageStyle,false))])])}
var staticRenderFns = []

export { render, staticRenderFns }